import React from "react";
import { SiteContext } from "@/context/SiteContext";

export default function useSite() {
  return React.useContext(SiteContext);
}
